import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatSort } from "@angular/material/sort";
import { MatTable } from "@angular/material/table";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { Location } from "@angular/common";
import { FormControl } from "@angular/forms";
import { DatePipe } from '@angular/common';
import { SpeakerList } from "./../../../models/speakerModel/speaker-list";
import { SpeakerService } from "./../../../core/services/speaker.service";
import { TranscriptionService } from "./../../../core/services/transcription.service";
import { ModalPreviousEditionsComponent } from "./../modal-previous-editions/modal-previous-editions.component";
import { TablaItem } from "./tabla-datasource";
import { TranscriptionMeetingListModel } from "src/app/models/transcriptionModel/transcription-meeting-list-model";
import { SpeakerCountry } from "src/app/models/speakerModel/speaker-country";
import { ModalNotificationComponent } from "../modal-notification/modal-notification.component";
import { VersionService } from "src/app/core/services/version.service";
import { GlobalComponents } from "../global-constants";
import { ModalWarningComponent } from "../modal-warning/modal-warning.component";
import { TranscriptionMeetingLocalModel } from "./../../../models/transcriptionModel/TranscriptionMeetingLocalModel";
import { UserService } from './../../../core/services/user.service';
import { Router } from "@angular/router";
import { MeetingService } from './../../../core/services/meeting.service';
import { Language } from '../../../models/languageModel/language';
import * as fileSaver from 'file-saver';
import { Observable, of } from "rxjs";
import { debounceTime, map, startWith } from 'rxjs/operators';
import { AccessControlService } from './../../../core/services/accessControl.service';
import { Download } from "src/app/models/downloadModel/download-model";
import { AudioPlayerPortalService } from "src/app/core/portals/audio-player-portal/audio-player-portal.service";
import { AudioService } from "src/app/core/services/audio.service";
@Component({
  selector: "app-edit",
  templateUrl: "./edit.component.html",
  styleUrls: ["./edit.component.scss"],
})

export class editComponent implements AfterViewInit, OnInit {
  username: string;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<TablaItem>;

  //Front variables
  file: string;
  meetingDate: string;
  meetingId: string;
  transcriptionDate: string;
  topic: string;
  words: number;
  orators: number;
  titleTable: string;
  finding: boolean = true;
  transcriptions: boolean = false;
  filters = [];
  result: boolean = true;

  //Data variables
  public idMeet: number;
  public idTrans: number;
  public start: any;
  public transcriptionMeeting: Array<TranscriptionMeetingListModel> = null;
  public transcriptionList: Array<TranscriptionMeetingLocalModel> = null;
  public oratorsList = new Array<SpeakerList>();
  public filterOratorOptions = new Observable<SpeakerList[]>();
  public countryList = new Array<SpeakerCountry>();
  public versionList: Array<number>; 

  selectedUsers: string[] = [];
  selectedIdUsers: number[] = [];

  countryForm = new FormControl();
  oratorForm = new FormControl();
  textForm = new FormControl();

  lastFilter: string = "";

  public SEC: boolean = false;
  public STB: boolean = false;
  public Directory: boolean = false;

  public filterCountryOptions: Observable<SpeakerCountry[]>;

  lastMeeting: any;
  lastLang: string;

  constructor(private _location: Location,
              private dialog: MatDialog,
              private active: ActivatedRoute,
              private transcriptionService: TranscriptionService,
              private speakerService: SpeakerService,
              private versionService: VersionService,
              public datepipe: DatePipe,
              private serviceUsers: UserService,
              private router: Router,
              private serviceMeeting: MeetingService,
              private accessControlService: AccessControlService,
              private serviceAudio: AudioService,
              private audioPlayerService: AudioPlayerPortalService
              ) {
  }

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  stbDisplayedColumns = ["transcriptionDetails"];
  technicalTeamDisplayedColumns = ["transcriptionDetails"];

  get displayedColumns(): string[] {
    if (this.username === "stb") {
      return this.stbDisplayedColumns;
    } else if (this.username === "technicalTeam") {
      return this.technicalTeamDisplayedColumns;
    } else {
      return this.stbDisplayedColumns;
    }
  }

  ngOnInit() {
    this.username = localStorage.getItem("username");    
    //starting initials
    this.initializeVariables();

    //Get parameters
    this.active.paramMap.subscribe((params: ParamMap) => {
      this.idMeet = Number(params.get("idMeeting"));
      this.idTrans = Number(params.get("idTranscription"));
      var start = this.active.snapshot.paramMap.get("start");
      this.start = start;

    });
    this.getUserRoles();
    this.verifyEdition();
    //Get Data
    this.getDataFilter(this.idMeet);
  
    this.oratorForm.valueChanges
    .pipe(
      startWith(''),
      // this.filter((value)=> typeof value !== 'object'),
      map((value) => this._filter(value))
    ).subscribe((users) => {
      this.filterOratorOptions = of(users);
    });
  }

  private _filter(search) {
    return this.oratorsList.filter(user => user.userName.toLowerCase().includes(search?.toLowerCase()) );
  }

  initializeVariables() {
    this.words = 0;
    this.orators = 0;
    this.titleTable = "";
    this.file = "";
    this.transcriptionDate = "";
    this.topic = "";
    this.meetingDate = "";
  }

  async getDataFilter(idMeet2) {
    //Get Countries List
    await this.speakerService.getCountriesMeeting(idMeet2).toPromise().then((resp) => {
      this.countryList = resp.countryList;
      this.filterCountryOptions = this.countryForm.valueChanges.pipe(
        startWith(""),
        map((value) => this.filteredCountry(value))
      );
    }, (error) => {
      this.result = false;
      this.finding = false;
      this.notificationModal(GlobalComponents.notSuccess);
    });

    await this.getSpeakerByMeeting(idMeet2);
  }

  async getSpeakerByMeeting(idMeet2) {
    //Get Orators List
    await this.speakerService.getSpeakerByMeeting(idMeet2).toPromise().then((resp2) => {
      this.oratorsList = resp2.data;
      this.filterOratorOptions = this.oratorForm.valueChanges.pipe(
        startWith(""),
        map((value) => this.filter(value))
      );
      this.orators = resp2.data.length;
    }, (error) => {
      this.result = false;
      this.finding = false;
      this.notificationModal(GlobalComponents.notSuccess);
    });

    await this.getFullTranscription(this.idMeet, false).then((result) => {
      setTimeout(() => {
        if(Number(this.idTrans) > 0) this.scrollInMarkOfTime();
      }, 500);
    })
  }

  scrollInMarkOfTime() {

    let keepGoing = true;

    this.transcriptionList.forEach(meeting => {
      if(keepGoing == true && new Date(this.start).getTime() <= new Date(meeting['startTrack']).getTime()) {
  
        const elemento = document.getElementById(`id-${meeting['startTrack']}`);
    
        elemento.scrollIntoView();

        keepGoing = false;
      }
      
    });

    let _keepGoing = true;

    this.transcriptionList.forEach(meeting => {
      if(_keepGoing == true && new Date(this.start).getTime() <= new Date(meeting['startTrack']).getTime()) {

        const parrafo = document.getElementById(`p-${meeting['startTrack']}`);
    
        parrafo.style.fontWeight = 'Bold';
        parrafo.style.color = "#d3701f"

        _keepGoing = false;
      }
    });

  }

  ngAfterViewInit() {
    /* this.dataSource.sort = this.sort;
    this.table.dataSource = this.dataSource; */
  }

  goBack() {
    this._location.back();
  }

  deselectOption() {
    this.countryForm.setValue(null);
  }

  async getFullTranscription(idMeet2, published) {
    this.versionList = [];

    await this.transcriptionService
      .getTranscriptionMeeting(idMeet2, published).toPromise().then((resp) => {
        let dateCreation = resp.dateCreation.toString().replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3");

          this.meetingDate = this.datepipe.transform(dateCreation, 'MM-dd-yyyy');
          this.topic = resp.topic;
          this.meetingId = resp.meetingId.toString();
          var meetingName = resp.meetingName;
          this.transcriptionList = new Array<TranscriptionMeetingLocalModel>();
          
          resp.data.forEach((element) => {
            this.words += element.wordCount;
            this.versionList?.push(element.versionNumber);
            let dateModify = element.dateModify.toString().replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3");
            this.transcriptionDate = this.datepipe.transform(dateModify, 'MM-dd-yyyy');

            let tDate = element.dateModify.toString().replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3");
            let dCreation = resp.dateCreation.toString().replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3");
            
            this.transcriptionList?.push({
              transcriptionId: element.transcriptionId,
              orador: element.orador,
              modifyBy: element.modifyBy,
              dateModify: this.datepipe.transform(tDate, 'MM-dd-yyyy'),
              transcriptionText: element.transcriptionText,
              versionNumber: element.versionNumber,
              wordCount: element.wordCount,
              dateCreation: this.datepipe.transform(dCreation, 'HH:mm:ss'),
              sentenceId: element.sentenceId,
              existInVersion: element.existInVersion,
              startTrack: element.startTrack,
              meetingName: meetingName,
              metadataId: element['metadataId'],
              drEventId: element['drEventId'],
              drRecId: element['drRecId'],
              interventionOrder: element['interventionOrder'],
            });
          });
          
          this.file = Math.max.apply(null, this.versionList);
          this.titleTable = "Transcription V." + Math.max.apply(null, this.versionList);
          this.finding = false;
          this.transcriptions = true;
          this.result = true;

      }, (error) => {
        this.result = false;
        this.finding = false;
        this.notificationModal(GlobalComponents.notSuccess);
      });
  }

  filterTranscription() {
    this.finding = true;
    var oratorValue: number[] = [];
    if(this.selectedIdUsers.length > 0){
      for(var i = 0; i < this.selectedIdUsers.length; i++){
        oratorValue?.push(this.selectedIdUsers[i]);
      };
    }
    if(oratorValue.length == 0)
    {
      oratorValue = null;
    }

    let filters = {
      idMeeting: this.idMeet,
      orator: oratorValue,
      country: this.countryForm.value,
      keyWord: this.textForm.value,
    };
    this.transcriptionService.getTranscriptionsMeetingByfilter(filters)
    .subscribe((resp) => {
        if (resp.success) {
          this.words = 0;
          let dateCreation = resp.dateCreation.toString().replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3");
          this.meetingDate = this.datepipe.transform(dateCreation, 'MM-dd-yyyy');
          this.topic = resp.topic;
          this.meetingId = resp.meetingId.toString();
          var meetingName = resp.meetingName;

          this.transcriptionList = new Array<TranscriptionMeetingLocalModel>();
          
          resp.data.forEach((element) => {
            this.words += element.wordCount;
            this.versionList?.push(element.versionNumber);
            let tDate = element.dateModify.toString().replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3");
            let dCreation = resp.dateCreation.toString().replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3");
            
            this.transcriptionList?.push({
              transcriptionId: element.transcriptionId,
              orador: element.orador,
              modifyBy: element.modifyBy,
              dateModify: this.datepipe.transform(tDate, 'MM-dd-yyyy'),
              transcriptionText: element.transcriptionText,
              versionNumber: element.versionNumber,
              wordCount: element.wordCount,
              dateCreation: this.datepipe.transform(dCreation, 'HH:mm:ss'),
              sentenceId: element.sentenceId,
              existInVersion: element.existInVersion,
              startTrack: element.startTrack,
              meetingName: meetingName,
              metadataId: element['metadataId'],
              drEventId: element['drEventId'],
              drRecId: element['drRecId'],
              interventionOrder: element['interventionOrder'],
            });
          });

          this.finding = false;
          this.transcriptions = true;
          this.result = true;

        }else{
          this.finding = false;
          this.result = false;
          this.transcriptionList = new Array<TranscriptionMeetingLocalModel>();
          return this.notificationModal('stt.search.noResult');
        }
      }, (error) => {
        this.result = false;
        this.finding = false;
        this.notificationModal(GlobalComponents.notSuccess);
      }
    );
  }

  DownloadPdf() {
    let currentLanguage: Language = JSON.parse(localStorage.getItem('languaje'));
    var languageId: number;
    if( currentLanguage.code == "es"){
      languageId = 1;
    }
    else{
      languageId = 2;
    }

    this.transcriptionService.getPdf(this.idMeet, languageId).toPromise()
    .then((response) => {      
      let tm = "";
      if(languageId == 1){
        tm = "_TranscripciónDeReunión_";
      }
      else{
        tm = "_MeetingTranscription_";
      }

      const blob = new Blob([response], { type: response.type });
      fileSaver.saveAs(blob, this.datepipe.transform(Date.now(), 'yyyyMMddHHmmss') + tm + this.idMeet + ".pdf")

      this.dialog.closeAll();
    }, (error) => {
      this.notificationModal(GlobalComponents.notSuccess);
    });
  }

  async openModalAudio(index, row, title) {

    this.audioPlayerService.attach({ title: title, startTime: row.startTrack, endTime: row.endTrack, link: null });
    await this.serviceAudio.getAudioMeeting(row.drRecId, row.drEventId, "Flo").then((audio) => {
      this.audioPlayerService.attach({ title: title, startTime: row.startTrack, endTime: row.endTrack, link: audio });
    })
  
  }

  openModalPreviousEditions(sentenceId: number) {
    const modalRef = this.dialog.open(ModalPreviousEditionsComponent, {
      width: "600px",
      maxHeight: "750px",
    });
    modalRef.componentInstance.sentenceId = sentenceId;
  }

  notificationModal(message: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      message: message,
      valor: 10,
    };
    const modalRef = this.dialog.open(ModalNotificationComponent, dialogConfig);
  }

  saveChangesTranscription(idTra, textTransc, transcriptRow) {
    let data = {
      transcriptionId: idTra,
      transcriptionText: textTransc,
      userEditor: this.username
    };
    if(textTransc.trim().length > 0){
    const modalRef = this.dialog.open(ModalWarningComponent, {
      width: "500px",
      maxHeight: "750px",
    });
    modalRef.componentInstance.text = 'stt.edit.confirmToSave';
    modalRef.componentInstance.finishDataPush.subscribe(($e) => {
      if ($e) {
        this.finding = true;
        this.transcriptionService
          .saveTranscriptionEdition(data)
          .subscribe((resp) => {
            if(resp.success){
              transcriptRow.existInVersion = false;
            }
            this.finding = false;
          }, err => {
            this.finding = false;
            this.notificationModal(GlobalComponents.notSuccess);
          });
      } else {
        this.clearData();
        this.getFullTranscription(this.idMeet, false).then(() => {
          this.finding = false;
        });
      }
    });
    }
    else{
      this.notificationModal('stt.edit.NoText');
    }
  }

  async postNewVersion(meetingId: number) {
    const modalRef = this.dialog.open(ModalWarningComponent, {
      width: "500px",
      maxHeight: "750px",
    });
    modalRef.componentInstance.text = 'stt.edit.confirmToPublic';

    modalRef.componentInstance.finishDataPush.subscribe(($e) => {
      if ($e) {
        this.finding = true;
        this.versionService
          .saveTranscriptionVersion(meetingId, this.username)
          .subscribe((resp) => {
            this.clearData();
            this.getFullTranscription(meetingId, false).then(() => {
              this.finding = false;
            });
          }, err => {
            this.finding = false;
            this.notificationModal(GlobalComponents.notSuccess);
          });
      }
    });
  }

  clearData() {
    this.transcriptionMeeting = null;
    this.meetingDate = null;
    this.topic = '';
    this.words;
    this.versionList = null;
    this.transcriptionDate = null;
    this.file = null;
    this.titleTable = null;
    this.transcriptions = null;

    return true;
  }

  async getUserRoles(){

    let roles = this.accessControlService.getRoles();

    if(roles.length == 0 ) {
      this.accessControlService.roles$.subscribe(role => {
        if(role.includes('SEC_Minutes_Officer') || role.includes('SEC_Minutes_Officers')) {
          this.STB = true;
        } else if(role.includes('Recording Searchers')) {
          this.SEC = true;
        } else if(role.includes('directory')) {
          this.Directory = true;
        }
      })

    } else {
      if(roles.includes('SEC_Minutes_Officer') || roles.includes('SEC_Minutes_Officers')) {
        this.STB = true;
      } else if(roles.includes('Recording Searchers')) {
        this.SEC = true;
      } else if(roles.includes('directory')) {
        this.Directory = true;
      }
    }
  }

  verifyEdition(){
    this.serviceMeeting.getMeetingById(this.idMeet).toPromise().then((resp) => {
      if(resp.data.editBy != null && resp.data.editBy != ""){
        if(resp.data.editBy != this.username){
          this.router.navigate(["/app/access"]);
        }
      }
    });
  }

  optionClicked(event: Event, user: any) {
    event.stopPropagation();
    this.toggleSelection(user);
  }

  toggleSelection(user: any) {
    user.selected = !user.selected;
    if (user.selected) {
      this.selectedUsers?.push(user.userName);
      this.selectedIdUsers?.push(user.speakerId);
    } else {
      let index = this.selectedUsers.indexOf(user.userName);
      this.selectedUsers.splice(index, 1);
      let index2 = this.selectedIdUsers.indexOf(user.speakerId)
      this.selectedIdUsers.splice(index2, 1);
    }
    this.oratorForm.setValue(this.selectedUsers);
  }

  resetOratorForm() {
    this.oratorForm.setValue(null);
    this.selectedUsers = [];
    this.selectedIdUsers = [];
    const subscription = this.filterOratorOptions.subscribe((users) => {
      users.forEach((user) => {
        user.selected = false;
      });
      
    });
    subscription.unsubscribe();
  }

  resetCountryForm() {
    this.countryForm.setValue(null);
    // this.selectedUsers = [];
    const subscription = this.filterCountryOptions.subscribe((users) => {
      // users.forEach((user) => {
      //   user.selected = false;
      // });
    });
    subscription.unsubscribe();
  }

  filter(filter: any): SpeakerList[] {
    this.lastFilter = filter;
    if (filter) {
      return this.oratorsList.filter((option) => {
        return option.userName;
      });
    } else {
      return this.oratorsList.slice();
    }
  }

  public filteredCountry(value: string): SpeakerCountry[] {

    let filterValue = "";
    if(value != null){
      filterValue = value.toLowerCase();

    }
      return this.countryList.filter((o) => {
        return  o.name?.toLowerCase()?.includes(filterValue)
      }
     
      );
  }
}
